module.exports = __webpack_public_path__ + "media/detective.7bbc6613.mp3";